import React, { Fragment, Suspense, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { CheckOffline, internet } from './components/CheckOnline/CheckOnline';
import ProtectedRoute, { SignUpRoute, LoginRoute } from './services/ProtectedRoute';

import LayoutComponent from './hoc/Layout/Layout';

import { CheckValue, setAccessControlData, videoThumbnail } from './services/CommonFunction';
import { cancelToken, mediaFile, staticVar, version } from './services/Constants';
import { selectIcon } from './components/UI/selector';
import { messageService } from './services/subscriberService';
import { useDispatch, useSelector } from 'react-redux';
import { createMedia, mediaUploadDataChange, selectAllUploadMedia, setError, updateMediaStatus, updateProgress, updateStatus } from './store/uploadMediaSlice';
import axio from './axio';
import axios from 'axios';

const SignUpSteps = React.lazy(() => import('./containers/SignUpSteps/SignUpSteps')) ;
const NewPassword = React.lazy(() => import('./containers/ForgotPassword/NewPassword/NewPassword')) ;
const ForgotPassword = React.lazy(() => import('./containers/ForgotPassword/ForgotPassword')) ;
const Login = React.lazy(() => import('../src/containers/Login/Login')) ;
const SignUp = React.lazy(() => import('../src/containers/SignUp/SignUp')) ;
const InternalLayout = React.lazy(() => import('./hoc/InternalLayout/InternalLayout')) ;
const LocalURL = React.lazy(() => import('./containers/LocalURL/Local')) ;
const AccessControl = React.lazy(() => import('./containers/AccessControl/AccessControl')) ;

const App = () => {
  const uploadMedia = useSelector(selectAllUploadMedia);
  const dispatch = useDispatch();
  const [isOnline,setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    if(uploadMedia.media.length) {
      if( uploadMedia.status === staticVar.idle ) {
        dispatch(updateStatus({ status: staticVar.loading}));
      } else if( uploadMedia.status === staticVar.loading ) {
        const upload = uploadMedia.media.filter( el => el.status === staticVar.upload);
        const loadMedia = uploadMedia.media.filter( el => el.status === staticVar.loading);
        if(upload.length) {
          if(!upload[0].uploadStart) {
            dispatch(mediaUploadDataChange({id:upload[0].id, data:{uploadStart: true}}));
            var config = {
              // cancelToken: axios.CancelToken(function executor(c) {
              //   cancelToken.token = c;
              //   cancelToken.id = upload[0].id;
              // }),
              onUploadProgress: (progressEvent) => {
                try {                  
                  var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  dispatch(updateProgress({progress:percentCompleted,data:upload[0]}));
                } catch (error) {
                  console.error(error);
                }
              }
            };
            uploadOnServer(upload[0],config, dispatch).then( res => {
              if(res.status) {
                dispatch(mediaUploadDataChange({id:upload[0].id, data:{uploadEnd: true}}));
                // if(cancelToken.id === upload[0].id) {
                //   cancelToken.token= null;
                //   cancelToken.id= null;
                // }
                // dispatch(createMedia({...fetchMediaById(upload[0].id), updated: true, is_media_upload_from_panel_completed: true}));
              } else {
                dispatch(setError({id:upload[0].id,err:res.data}));
                // if(cancelToken.id === upload[0].id) {
                //   cancelToken.token= null;
                //   cancelToken.id= null;
                // }
              }
            });
          } else if(upload[0].uploadEnd) {
            dispatch(createMedia({...upload[0], firstTime: true, updated: true, is_media_upload_from_panel_completed: true}));
          }
        } else if(loadMedia.length) {
          if(!loadMedia[0].uploadStart && !loadMedia[0].startOnserver) {
            dispatch(mediaUploadDataChange({id:loadMedia[0].id, data:{startOnserver: true}}));
            dispatch(createMedia(loadMedia[0]));
          } else {

          }
        } else {
          dispatch(updateStatus({ status: staticVar.idle}));
        }
      }
    }
  },[uploadMedia.media,dispatch]);
    
  useEffect(() => {
    if(uploadMedia.status === staticVar.loading) {
      if(uploadMedia.media.length) {
        const newArr = uploadMedia.media.filter( el => el.status === staticVar.idle);
        if(newArr.length) {
          dispatch(updateMediaStatus({ status: newArr[0].createOnServer && newArr[0].type.toLowerCase() !== staticVar.image? staticVar.upload:staticVar.loading, id: newArr[0].id }));
        } else {
          dispatch(updateStatus({ status: staticVar.idle}));
        }  
      } else {
        dispatch(updateStatus({ status: staticVar.idle}));
      }
    } else if(uploadMedia.status === staticVar.idle) {
      if(uploadMedia.media.length ) {
        const newArr = uploadMedia.media.filter( el => el.status === staticVar.idle);
        if(newArr.length) {
          dispatch(updateStatus({ status: staticVar.loading}));
        }  
      }
    }
  },[uploadMedia.status,dispatch]);
  
  useEffect(() => {
    console.info('version:',version);
    if(localStorage.getItem('latest-coach-panel')) {
      setTimeout(() => {
        localStorage.removeItem('latest-coach-panel')
      },20000)
    }
    if(localStorage.getItem('access')) {
      const temp = JSON.parse(localStorage.getItem('access'));
      setAccessControlData(temp);
    }
    if(!CheckValue(internet.offline)) {
      let temp = selectIcon('offline');
      convertImgToBase64URL(temp);
    }

    eventListener('addEventListener');
    return () => {
      eventListener('removeEventListener');
    }
  },[]);

  const eventListener = (status) => {
    document[status]("visibilitychange", () => {
      if (document.hidden) {
        localStorage.setItem('hidden',+new Date());
         // tab is changed
      } else {
        const hiddenTime = localStorage.getItem('hidden');
        if(CheckValue(hiddenTime)) {
          localStorage.removeItem('hidden');
          const currentTime = +new Date();
          if(!CheckValue(localStorage.getItem('currentActivityId')) && ((currentTime - Number(hiddenTime)) >= (1000 * 60 * 60 * 1))) { // milisecond * second * minute * hour
            window.location.reload(true);
          }
        }        
         // tab is active
      }
    });
    window[status]("offline", (e) => {
      setIsOnline(false);
      console.info("offline");
    });

    window[status]("online", (e) => {
      setIsOnline(true);
      console.info("online");
    });

  }

  const polling = {
    url: CheckValue(localStorage.getItem('polling'))?localStorage.getItem('polling'): 'https://api.ipify.org/?format=json/'
  };

  return (
    <Fragment>
      {isOnline?
              <LayoutComponent>          
              <Suspense fallback={<div></div>}>
                <Switch>
                  <Route exact path="/localUrl" component={LocalURL} />
                  <Route exact path="/accessControl" component={AccessControl} />
                  <SignUpRoute path="/SignUpSteps" component={SignUpSteps} />
                  <LoginRoute exact path="/Login" component={Login} />
                  <LoginRoute path="/SignUp" exact component={SignUp} />
                  <LoginRoute path="/ForgotPassword" exact component={ForgotPassword} />
                  <Route path="/setPassword" exact render={(props) => <NewPassword user='_setPassword' {...props} />} />
                  <Route path="/Coach/NewPassword/:id" exact render={(props) => <NewPassword user='_resetCoachPassword' {...props} />} />
                  <Route path="/Member/NewPassword/:id/:appId" exact render={(props) => <NewPassword user='_resetMemberPassword' {...props} />} />
                  <Route path="/Member/NewPassword/:id" exact render={(props) => <NewPassword user='_resetMemberPassword' {...props} />} />
                  {/* ================Redirect to dashboard==================== */}
                  <ProtectedRoute path="/" component={InternalLayout} />
                </Switch>
              </Suspense>
            </LayoutComponent>
    
      :<CheckOffline />}
    </Fragment>
  );
}

function convertImgToBase64URL(url, callback, outputFormat){
  var img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = function(){
    var canvas = document.createElement('CANVAS'),
    ctx = canvas.getContext('2d'), dataURL;
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL(outputFormat);
    internet.offline = dataURL;
    canvas = null; 
  };
  img.src = url;
}

const uploadOnServer = async (data,config,dispatch) => {
  try {
    const fd = new FormData();
    fd.append('key', data.presigned_url_key.fields.key);
    fd.append('Policy', data.presigned_url_key.fields.Policy);
    fd.append('X-Amz-Credential', data.presigned_url_key.fields['X-Amz-Credential']);
    fd.append('X-Amz-Algorithm', data.presigned_url_key.fields['X-Amz-Algorithm']);
    fd.append('X-Amz-Date', data.presigned_url_key.fields['X-Amz-Date']);
    fd.append('X-Amz-Signature', data.presigned_url_key.fields['X-Amz-Signature']);
    fd.append('acl', data.presigned_url_key.fields['acl']);
    fd.append('file', mediaFile[data.id]);
    if(data.type.toLowerCase() === staticVar.video && !CheckValue(data.image_url_thumb)) {
      uploadThumbnail(mediaFile[data.id], data, dispatch);
    }
    messageService.show = false;
    await axio.post(data.presigned_url_key.url, fd, config);
    return {status:true};
  } catch (error) {
    console.error(error.message);
    if(axios.isCancel(error)) {
      console.error('im canceled');  
    }
    else {
      console.error('im server response error');
    }
    return {status:false, data:error.message};
  }
}

const uploadThumbnail = async  (currentFile, data, dispatch) => {
  const url = URL.createObjectURL(currentFile);
  await videoThumbnail(url,10).then(res => {
    if(CheckValue(res)) {
      dispatch(createMedia({...data, updated: true, file: res.file}));
    }
  })
  .catch(err => {
    console.error('err',err);
  });
}

export default App;
